<template>
  <article class="message is-primary">
    <div class="message-header">
      <p>{{ $t(`title.${name}`) }}</p>
    </div>
    <div class="message-body">
      <div class="columns">
        <div class="column b-portlet" style="background-color: rgb(251, 251, 251);">
          <div class="b-portlet-body" style="height:450px;">
            <content
              class="content"
              style=" overflow-y: scroll; height: 400px; position: absolute; padding:20px"
              v-html="htmlContent"
            ></content>
          </div>
          <div class="b-portlet-footer">
            <div class="b-button-container">
              <button class="button is-primary is-pulled-right" @click="close()">
                {{ $t('button.ok') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    htmlContent: { type: String, default: '' }
  },
  methods: {
    close() {
      this.$emit('saved')
      this.$parent.close()
    }
  }
}
</script>
